import { InvoiceSpecificationStoresForm } from "@/schemas/invoiceSpecificationStoresForm";
import { ReadLaborCostsInStores } from "@/schemas/laborCostsInStores";
import { useMemo } from "react";
import { calculateBaseAmount } from "../utils/calculateBaseAmount";
import { calculateInvoicedAmount } from "../utils/calculateInvoicedAmount";

export const useLaborCostsInStoresFormDefaultValues = (
  data: ReadLaborCostsInStores[],
) => {
  return useMemo(() => {
    return {
      stores: data.reduce(
        (stores, item) => {
          const baseAmount = calculateBaseAmount({
            hours: item.hours,
            rate: item.rate,
          });

          const invoicedAmount = calculateInvoicedAmount({
            base_amount: String(baseAmount),
            addition: item.addition,
            deduction: item.deduction,
          });

          stores[item.id] = {
            id: item.id,
            store_id: item.store_id,
            hours: String(item.hours || 0),
            deduction: String(item.deduction || 0),
            rate: String(item.rate || 0),
            planned_hours: String(item.planned_hours || 0),
            include_on_invoice: item.include_on_invoice ?? true,
            addition: String(item.addition || 0),
            comment: item.comment || "",
            base_amount: Number(baseAmount).toFixed(3),
            invoiced_amount: Number(invoicedAmount).toFixed(3),
          };
          return stores;
        },
        {} as InvoiceSpecificationStoresForm["stores"],
      ),
    };
  }, [data]);
};
